<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row>
      <v-card min-width="100%">
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center red--text subtitle-2">Costo smartphone</th>
                  <th class="text-center red--text subtitle-2">Costo ricambi</th>
                  <th class="text-center red--text subtitle-2">Costo accessori</th>
                  <th class="text-center red--text subtitle-2">IVA</th>
                  <th class="text-center green--text subtitle-2">Utile</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{smartphoneCost || 0}}€</td>
                  <td class="text-center">{{replacementsCost || 0}}€</td>
                  <td class="text-center">{{accessoriesCost || 0}}€</td>
                  <td class="text-center">{{vat ||0}}€</td>
                  <td class="text-center">{{gain || 0}}€</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-row>
    <br>
    <v-row>
      <v-card min-width="100%">
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="true"
          autocomplete="off"
        >

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Ricerca smartphone"
                    v-model="model"
                    :search-input.sync="search"
                    :items="searchItems"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                    :rules="[rules.required]"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Prezzo"
                    v-model="repair.smartphone.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Pezzi di Ricambio</h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Cerca"
                    v-model="replacementModel"
                    :search-input.sync="replacementSearch"
                    :items="replacementSearchItems"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="pt-8"
                >
                  <v-btn
                    small
                    color="primary"
                    @click="add('replacement')"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, index) in repair.replacements"
                        :key="index"
                      >
                        <v-list-item-icon>
                          <v-icon
                            color="red"
                            @click="remove('replacement', index)"
                          >mdi-delete</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{item.name}} {{item.model}} {{item.state}} {{item.color || ''}} {{item.supplier_name}} | {{item.cost}}€</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Accessori Mancanti</h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Cerca"
                    v-model="accessoryModel"
                    :search-input.sync="accessorySearch"
                    :items="accessorySearchItems"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="pt-8"
                >
                  <v-btn
                    small
                    color="primary"
                    @click="add('accessory')"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, index) in repair.accessories"
                        :key="index"
                      >
                        <v-list-item-icon>
                          <v-icon
                            color="red"
                            @click="remove('accessory', index)"
                          >mdi-delete</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{item.serial_code}} {{item.brand}} {{item.model}} {{item.color || ''}} {{item.description || ''}} | {{item.cost}}€ {{item.supplier_name}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-actions>
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="submit"
                  >
                    Salva riparazione
                  </v-btn>

                  <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                  >
                    Reset Modulo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'
  import { accounting } from './../../../mixins/accounting'

  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification
    },
    mixins: [accounting],
    data() {
      return {
        repair: {
          smartphone: {
            id: null,
            cost: null,
            price: null
          },
          replacements: [],
          accessories: []
        },
        valid: false,
        search: '',
        replacementSearch: '',
        accessorySearch: '',
        model: null,
        replacementModel: null,
        accessoryModel: null,
        searchItems: [],
        replacementSearchItems: [],
        accessorySearchItems: [],
        isLoading: false,
        snack: {
          error: null,
          visible: null,
          message: null
        },
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },
    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT'
      ]),
      add(kind) {

        if (kind === 'replacement') {
          if (!this.replacementModel) return

          this.repair.replacements.push(this.replacementModel)

        } else if (kind === 'accessory') {
          if (!this.accessoryModel) return

          this.repair.accessories.push(this.accessoryModel)
        }
      },
      remove(kind, index) {
        if (kind === 'replacement') {
          this.repair.replacements.splice(index, 1)
        } else if (kind === 'accessory') {
          this.repair.accessories.splice(index, 1)
        }
      },
      async submit() {
        if (this.$refs.form.validate() && (this.repair.replacements.length > 0 || this.repair.accessories.length > 0)) {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })

          const { data } = await axios.post(`${process.env.VUE_APP_API}/repairs/bytewood/create`, this.repair, this.config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Articolo salvato correttamente!'
            })

            this.reset()
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }

        }
      },
      reset() {
        this.$refs.form.reset()
        this.repair = {
          smartphone: {
            id: null,
            cost: null,
            price: null
          },
          replacements: [],
          accessories: []
        }
      },
    },
    computed: {
      smartphoneCost() {

        return this.repair.smartphone.cost
      },
      replacementsCost() {

        if (this.repair.replacements.length < 1) return

        return this.repair.replacements.map((el) => {
          return el.cost
        }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
      },
      accessoriesCost() {

        if (this.repair.accessories.length < 1) return

        return this.repair.accessories.map((el) => {
          return el.cost
        }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
      },
      vat() {
        const cost = parseFloat(this.repair.smartphone.cost || 0)
        const price = parseFloat(this.repair.smartphone.price || 0)

        if (cost <= 0 && price <= 0) return

        const res = this._calculateVat(cost, price, true).toFixed(2)

        return res > 0 ? res : "0"
      },
      gain() {
        const price = parseFloat(this.repair.smartphone.price || 0).toFixed(2)
        const cost = parseFloat(this.repair.smartphone.cost || 0).toFixed(2)
        const extra = (parseFloat(this.replacementsCost || 0) + parseFloat(this.accessoriesCost || 0)).toFixed(2)
        const vat = parseFloat(this.vat || 0).toFixed(2)

        if (!this.vat || !price) return

        return parseFloat(price - vat - cost - extra).toFixed(2)
      }
    },
    watch: {
      async search(val) {
        if (this.isLoading) return
        if (this.model) return

        this.isLoading = true

        const body = {
          term: val
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/repairs/bytewood/fetch-to-repair`, body, this.config)

        this.searchItems = data.map(el => {

          el.text = `[${el.supplier_name}] ${el.serial_number} ${el.ean || ''} ${el.brand} ${el.model} ${el.color}, ${el.disk_space} / ${el.ram} ${el.desctiption || ''}`

          return el
        })

        this.isLoading = false
      },
      async replacementSearch(val) {
        if (this.isLoading) return
        // if (this.model) return

        this.isLoading = true

        const body = {
          term: val
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/replacements/search`, body, this.config)

        this.replacementSearchItems = data.map(el => {

          if (el.amount) {

            el.text = `${el.amount}x ${el.name} ${el.model} ${el.state} ${el.color || ''} ${el.supplier_name} | ${el.cost}€`

            return el
          }
        })

        this.isLoading = false
      },
      async accessorySearch(val) {
        if (this.isLoading) return
        // if (this.model) return

        this.isLoading = true

        const body = {
          term: val
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/accessories/search`, body, this.config)

        this.accessorySearchItems = data.map(el => {

          if (el.amount) {

            el.text = `${el.amount}x ${el.serial_code} ${el.brand} ${el.model} ${el.color || ''} ${el.description || ''} | ${el.cost}€ ${el.supplier_name}`

            return el
          }
        })

        this.isLoading = false
      },
      model(val) {
        if (val) {
          this.repair.smartphone.id = val.id
          this.repair.smartphone.cost = val.cost
          this.repair.smartphone.price = val.price
        }
      }
    }
  }
</script>

<style>
</style>